import React from "react";

// Word-level diff: renders the original with removed words struck-through in
// red and the suggested name with added words highlighted in green.
function tokenize(s) {
  return (s || "").split(/(\s+|[_\-.])/).filter((t) => t !== "");
}

export function OriginalDiff({ original, suggested }) {
  if (original === suggested) {
    return <span className="text-neutral-400">{original}</span>;
  }
  const a = tokenize(original);
  const bSet = new Set(tokenize(suggested).map((t) => t.toLowerCase()));
  return (
    <span className="text-neutral-500">
      {a.map((tok, i) => {
        const removed = tok.trim() && !bSet.has(tok.toLowerCase());
        return (
          <span
            key={i}
            className={
              removed
                ? "line-through decoration-[#FF3B30]/70 text-[#FF3B30]/80"
                : ""
            }
          >
            {tok}
          </span>
        );
      })}
    </span>
  );
}

export function SuggestedDiff({ original, suggested }) {
  if (original === suggested) {
    return <span className="text-neutral-500">{suggested}</span>;
  }
  const aSet = new Set(tokenize(original).map((t) => t.toLowerCase()));
  const b = tokenize(suggested);
  return (
    <span className="text-white">
      {b.map((tok, i) => {
        const added = tok.trim() && !aSet.has(tok.toLowerCase());
        return (
          <span key={i} className={added ? "text-[#34C759] font-medium" : ""}>
            {tok}
          </span>
        );
      })}
    </span>
  );
}
